import '../css_styles/button_styles.css'
import '../css_styles/window_canvas_styles.css'

// imports relevant for HTTP calls
// import { useAuth0 } from '@auth0/auth0-react';
import DisplayException from '../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import { SERVER_URL } from '../config_server_url';


import PaginatedTable from '../tables/PaginatedTable';
import UserSessionContext from '../user_session/context_user_session';

import { useContext, useState, useEffect } from 'react';

function DesignSpaceViewer(props) {

    // const { user } = useAuth0();
    const usr_session_ctx = useContext(UserSessionContext);
    const [isLoading, setIsLoading] = useState(false);
    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');

    // ------------------ General Window Layout -----------------------------
    const [title, setTitle] = useState('')
    const[factors, setFactors] = useState([]);
    const [validated, setValidated] = useState(true);



    useEffect( () => {
        if(typeof props.validated !== 'undefined'){ setValidated(props.validated); }
        else { setValidated(false); }
        }, [props.validated]);

    useEffect( () => {
        if (props.campaign_objects.uuid_design_space !== '') {
            setIsLoading(true);
            const fetchDesignSpace = async () => {
                    setIsLoading(true);
                    const uuid_design_space = props.campaign_objects.uuid_design_space;
                try {
                    const response = await fetch(`${SERVER_URL}/current_project/load_design_space/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'uuid_tenant': usr_session_ctx.uuid_tenant
                        },
                        body: JSON.stringify(uuid_design_space),
                    });
        
                    if (!response.ok) {
                        throw new Error(`HTTP error ${response.status}`);
                    }
        
                    const data = await response.json();
                    setFactors(data.data.factors);
                    setTitle(data.data.title);
                    setIsLoading(false);
                } catch (err) {
                    setIsLoading(false);
                    setException(true);
                    setExceptionMessage(`HTTPException: err_msg=${err.message}`);
                } 
            };
            fetchDesignSpace();
        }
    }, [props.campaign_objects.uuid_design_space]);


    let viewer = (<></>)
    if(isLoading && !Exception){
        viewer = (<div className = {'builder_canvas'} >
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </div>);
    }

    if(Exception){
        viewer = (<>
                    <div className = {'builder_canvas'} >
                        <DisplayException>
                            {ExceptionMessage}
                        </DisplayException>  
                    </div>
                </>);
    }


    if(!isLoading && !Exception){
        let table_rows = []
        factors.forEach( (factor, id) => {
            let range = ''
            if (factor.type === 'Continuous' && factor.range_min !== null && factor.range_max !== null) { 
                range = `[${factor.range_min}, ${factor.range_max}]`; 
            }
            table_rows.push({factor_name: factor.name, type:factor.type, range: range, units: factor.units, remarks: factor.remarks});
        });


        let rquires_validation = <></>
        if(!validated){
            rquires_validation = (<>
                            <div style={{marginLeft:'20px', marginTop:'10px', marginBottom:'15px', display:'flex', justifyItems:'center'}}>
                                <button 
                                    // className={'actionButtonTiny'}
                                    className={'tableButton'}
                                    style={{marginTop:'0px', width:'130px', marginLeft: '0px', marginBottom:'px'}}
                                    onClick={props.onEdit}
                                    >
                                    validate in editor
                                </button>
                                <div style={{margin:'0px', padding:'0px', fontSize:'14px', color:'var(--aixelo-red)'}}>Changes in Experimental Workflow require Design Space (re)validation.</div>
                            </div>
                        </>);
        }

        let action_panel = (<></>);
        if(typeof props.hideActionPanel === 'undefined' || !props.hideActionPanel) {
            action_panel = (<>
                    <div style={{position: 'relative', display:'flex', marginLeft: '10px', marginTop:'10px', paddingTop:'10px',
                            marginBottom:'0px', height:'fit-content', width:'fit-content'}}>   
                        <button className={'tableButton'} onClick={props.onEdit} style={{width: '95px', paddingBottom: '3px', paddingTop: '3px', marginBottom: '0px'}}>Edit</button>
                        {/* <button className={'tableButton'} style={{marginRight: '10px', width: '95px', paddingBottom: '3px', paddingTop: '3px', marginBottom: '0px'}} >Delete</button>
                        <button className={'tableButton'} style={{width: '95px', paddingBottom: '3px', paddingTop: '3px', marginBottom: '0px'}} >Load</button>
                        <button className={'tableButton'} style={{width: '95px', paddingBottom: '3px', paddingTop: '3px', marginBottom: '0px'}} >Create New</button> */}
                    </div>  
                </>);
        }
        

        viewer = (<>
                    <div className = {'viewer_canvas'} style={{height:props.height-120}}>
                        <p style = {{marginLeft: '20px', marginTop: '10px', marginBottom: '3px', fontSize: '18px', fontWeight:'bold', position: 'relative', width:'94%'}} >
                            Title: {title}
                        </p>
                        {/* <div style = {{marginLeft: '20px', marginTop: '0px', marginBottom: '3px', fontSize: '12px', position: 'relative', width:'fit-content'}} >
                            Derived from Experimental Workflow (uuid: {props.uuid_experimental_setup})
                        </div> */}
                        <div style = {{marginLeft: '20px', marginTop: '0px', marginBottom: '3px', fontSize: '12px', position: 'relative', width:'fit-content'}} >
                            uuid: {props.campaign_objects.uuid_design_space}
                        </div>
                        <div style = {{marginLeft: '20px', marginTop: '0px', marginBottom: '3px', fontSize: '12px', position: 'relative', width:'fit-content'}} >
                            Factor names are derived from Experimental Workflow with uuid: {props.campaign_objects.uuid_experimental_setup}
                        </div>
                        <div style={{position: 'relative', marginLeft:'20px', marginTop:'20px', height:'fit-content', width:'95%'}}>
                            <PaginatedTable colNames={['Factor Name', 'Type', 'Range', 'Unit', 'Remarks']}
                                            tableRows={table_rows}
                                            itemsPerPage={15} />
                        </div>
                        {rquires_validation}
                    </div>
                    {action_panel}
                </>
                );
    }
    return (<>
                {viewer}
            </>);
}

export default DesignSpaceViewer